import { invalidateUserKeywords } from '@/composables/keywords/useUserKeywords';
import { resetSingleFeed } from '@/composables/feed/useSingleFeed';

export const handleUserKeywordsSuccessChange = ({ queryClient }) => {
  invalidateUserKeywords({ queryClient });
  resetSingleFeed({ queryClient });
};
